export const WORKFLOW_EDITOR_TOOLBAR_CLASS =
  "flex h-auto min-h-14 shrink-0 flex-wrap items-center gap-2 border-b px-3 py-2 sm:flex-nowrap sm:px-4"

export const WORKFLOW_EDITOR_TOOLBAR_CONTROLS_CLASS =
  "flex min-w-0 flex-1 flex-wrap items-center gap-2"

export const WORKFLOW_EDITOR_TOOLBAR_ACTIONS_CLASS =
  "flex min-w-0 flex-1 flex-wrap items-center justify-end gap-2 sm:ml-auto sm:flex-none sm:flex-nowrap"
